import type { EventCallback } from "@tauri-apps/api/event";
import tauri from "./";

namespace MixitoneEvent {
  export type SyncStarted = object;
  export type SyncProgress = {
    message: string;
  };
  export type SyncFinished = object;
  export type SyncError = {
    message: string;
  };
  export type SyncOffline = Record<string, never>;
}

type MixitoneEvents = {
  "mixitone:sync:progress": MixitoneEvent.SyncProgress;
  "mixitone:sync:started": MixitoneEvent.SyncStarted;
  "mixitone:sync:finished": MixitoneEvent.SyncFinished;
  "mixitone:sync:error": MixitoneEvent.SyncError;
};

export function listen<T extends keyof MixitoneEvents>(event: T, callback: EventCallback<MixitoneEvents[T]>) {
  return tauri.listen<MixitoneEvents[T]>(event, callback) as Promise<() => void>;
}
